import React, { useEffect, useRef } from 'react';

function NotesCasesSortPopup({ selectedSort, onSelect, onClose }) {
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const options = [
    { id: 'Name A-Z', label: 'Name A-Z' },
    { id: 'Name Z-A', label: 'Name Z-A' },
    { id: 'Recently Added', label: 'Recently Added' },
    { id: 'Oldest First', label: 'Oldest First' },
  ];

  return (
    <div className="popup-dropdown sort-dropdown" ref={containerRef}>
      <div className="popup-title">Sort By</div>
      <div className="popup-options">
        {options.map((opt) => (
          <button
            key={opt.id}
            type="button"
            className={`popup-option-btn ${selectedSort === opt.id ? 'active' : ''}`}
            onClick={() => {
              onSelect(opt.id);
              onClose();
            }}
          >
            <span>{opt.label}</span>
            {selectedSort === opt.id && (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

export default NotesCasesSortPopup;
